/* eslint-disable check-file/filename-naming-convention */

export const LoaderSelector = 'ui-kit-loader';
